import { render } from "./PaymentFailView.vue?vue&type=template&id=297e3c99&ts=true"
import script from "./PaymentFailView.vue?vue&type=script&lang=ts"
export * from "./PaymentFailView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__